<template>
  <div class="w-11/12 mx-auto pt-10" :class="{ 'iframe-mode': isInIframe }">
    <div class="text-zt-xl" :class="primaryTextClass">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <button class="h-8 w-8 back-button" @click="goBack()" v-on="on" data-vs-button="toLicenceManager">
            <zt-icon name="arrow-left" class="pb-2 mt-1 pr-1" />
          </button>
        </template>
        <span>{{ $t("message.LicensesManager.goBack") }}</span>
      </v-tooltip>
      <span class="ml-1">{{ $t("message.LicensesManager.holidays.title") }}</span>
    </div>
    <div class="mt-3 flex flex-wrap w-full">
      <div class="w-2/4">
        <v-select
          class="selectLicenseProperty"
          :items="years"
          v-model="yearSelected"
          @change="changeYear"
          :color="primaryColor"
          solo
          data-vs-select="yearSelected"
        ></v-select>
      </div>
    </div>
    <div class="mt-3 flex flex-wrap w-full">
      <span class="text-zt-lg" :class="primaryTextClass">{{ $t("message.LicensesManager.holidays.subtitle", {year: yearSelected}) }}</span>
    </div>
    <div class="mt-3 flex flex-wrap w-full pb-4">
      <v-data-table
        :headers="headers"
        :items="holidaysList"
        item-key="id"
        class="elevation-1 w-full"
        :rows-per-page-items="[8, 15, 30]"
        :pagination.sync="pagination"
        :total-items="holidaysTotal"
        :loading="loading"
        :no-data-text="$t('message.datatable.noDataText')"
      >
        <template v-slot:items="props">
          <tr>
            <td class="text-zt-base text-zt-dark-500">{{ props.item.fecha | fullDate }}</td>
            <td class="text-zt-base text-zt-dark-500">{{ props.item.detalle }}</td>
            <td class="text-zt-base text-zt-dark-500">{{ parseHolidayType(props.item) }}</td>
          </tr>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import Licenses from '@/apiClient/Licenses'
import moment from 'moment'
import { mapGetters } from "vuex"

export default {
  data() {
    return {
      licenses: Licenses,
      years: [],
      yearSelected: '',
      holidaysList: [],
      holidaysTotal: 0,
      pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 8,
        sortBy: null,
        totalItems: this.holidaysTotal
      },
      headers: [
        { 
          text: `${this.$t("message.LicensesManager.holidays.day")}`, 
          align: 'left', 
          sortable: false, 
          value: 'fecha'
        },
        { 
          text: `${this.$t("message.LicensesManager.holidays.name")}`, 
          sortable: false, 
          align: 'left', 
          value: 'detalle'
        },
        { 
          text: `${this.$t("message.LicensesManager.holidays.type")}`, 
          sortable: false, 
          align: 'left',
        }
      ],
      loading: false,
    }
  },
  computed: {
    ...mapGetters({
      locale: 'getLocaleForDatepicker'
    }),
    isInIframe() {
      return this.$iframeMessages && this.$iframeMessages.isTokenValid();
    },
    primaryTextClass() {
      return this.isInIframe ? 'text-iframe-primary' : 'text-zt-primary-200';
    },
    primaryColor() {
      return this.isInIframe ? '#2694fc' : '#4f41a3';
    }
  },
  watch: {
    pagination: {
      handler () {
        this.getHolidays()
      },
      deep: true
    },
  },
  created() {
    moment.locale(this.locale)
    let currentYear = moment().format('YYYY')
    let nexttYear = moment().add(1, 'years').format('YYYY')
    this.years = [currentYear, nexttYear]
    this.yearSelected = currentYear

    this.licenses = new Licenses()
    this.getHolidays()
  },
  filters: {
    fullDate: value => {
      return moment(value, 'DD/MM/YYYY').format('dddd DD/MM/YYYY')
    }
  },
  methods: {
    changeYear(){
      this.pagination.page = 1
      this.getHolidays()
    },
    getHolidays(){
      this.loading = true
      const { sortBy, descending, page, rowsPerPage } = this.pagination

      this.licenses.getHolidays(null, `01/01/${this.yearSelected}`, `31/12/${this.yearSelected}`, rowsPerPage, page)
        .then(res => {
          this.holidaysList = res.data.results.data
          this.holidaysTotal = res.data.pagination.total
          this.loading = false
        })
        .catch(err => {
          this.loading = false
        })
    },
    parseHolidayType(item){
      if(item.id_politica !== null && item.id_politica !== 0){
        return this.$t("message.LicensesManager.holidays.politicHoliday")
      }else if(item.id_empresa !== null && item.id_empresa !== 0){
        return this.$t("message.LicensesManager.holidays.companyHoliday")
      }else{
        return this.$t("message.LicensesManager.holidays.countryHoliday")
      }
    },
    goBack() {
      this.$route.params.routerGo === 'manager' ? this.$router.push('/manager-licenses-page') : this.$router.push('/licenses-manager')
    },
  }
}
</script>
<style lang="scss" scoped>
.back-button:hover {
  background-color: #E0E0E0;
  border-radius: 9999px;
}

/* Estilos para modo iframe */
.iframe-mode {
  ::v-deep .v-select {
    .v-input__slot {
      &::before {
        border-color: #2694fc !important;
      }
    }
    
    &.v-input--is-focused {
      .v-input__slot::after {
        border-color: #2694fc !important;
      }
    }
  }
  
  ::v-deep .v-select__selection--comma {
    color: #2694fc !important;
  }
  
  /* Forzar color azul en loader circular */
  ::v-deep .v-progress-circular {
    color: #2694fc !important;
    stroke: #2694fc !important;
  }
  
  /* Forzar color azul en TODOS los elementos del progress bar */
  ::v-deep .v-progress-linear {
    // Background del progress bar
    .v-progress-linear__background.primary {
      background-color: rgba(38, 148, 252, 0.3) !important;
    }
    
    // Barras indeterminadas con clase primary
    .v-progress-linear__bar__indeterminate.long.primary,
    .v-progress-linear__bar__indeterminate.short.primary {
      background-color: #2694fc !important;
    }
    
    // Por si acaso, también sobrescribir sin la clase primary
    .v-progress-linear__bar__indeterminate {
      &.long, &.short {
        background-color: #2694fc !important;
      }
    }
    
    // Barra determinada
    .v-progress-linear__bar__determinate {
      background-color: #2694fc !important;
    }
  }
  
  /* Fix para dropdown de paginación - solo la lista desplegable */
  ::v-deep .v-datatable__actions {
    .v-select {
      .v-input__slot {
        color: inherit !important;
      }
      
      .v-select__selection {
        color: inherit !important;
      }
    }
  }
}

// Fix global para la lista desplegable del paginador - solo el ítem activo
::v-deep .v-menu__content {
  .v-list__tile--active {
    color: #2694fc !important;
    
    .primary--text {
      color: #2694fc !important;
    }
  }
}

.text-iframe-primary {
  color: #2694fc !important;
}
</style>